import type { CommitmentStatus, DealStatus, OrderStatus, RoundStatus } from "@dishour/shared";

const base = "inline-block rounded-full px-2 py-0.5 text-xs font-medium";

const ROUND_LABELS: Record<RoundStatus, { text: string; className: string }> = {
  open: { text: "모집 중", className: "bg-emerald-100 text-emerald-800" },
  confirming: { text: "최종 확인", className: "bg-amber-100 text-amber-800" },
  confirmed: { text: "확정", className: "bg-sky-100 text-sky-800" },
  cancelled: { text: "취소됨", className: "bg-stone-200 text-stone-600" },
  closed: { text: "종료", className: "bg-stone-200 text-stone-600" },
};

const COMMITMENT_LABELS: Record<CommitmentStatus, { text: string; className: string }> = {
  soft: { text: "참여 의사", className: "bg-stone-100 text-stone-700" },
  confirmed: { text: "최종 확인함", className: "bg-emerald-100 text-emerald-800" },
  fulfilled: { text: "수령 완료", className: "bg-sky-100 text-sky-800" },
  no_show: { text: "미확인", className: "bg-red-100 text-red-700" },
  undelivered: { text: "공급 실패", className: "bg-red-100 text-red-700" },
};

const DEAL_LABELS: Record<DealStatus, { text: string; className: string }> = {
  open: { text: "판매 중", className: "bg-emerald-100 text-emerald-800" },
  closed: { text: "마감", className: "bg-stone-200 text-stone-600" },
  expired: { text: "기간 만료", className: "bg-stone-200 text-stone-600" },
};

export const RoundStatusBadge = ({ status }: { status: RoundStatus }) => (
  <span className={`${base} ${ROUND_LABELS[status].className}`}>{ROUND_LABELS[status].text}</span>
);

export const CommitmentStatusBadge = ({ status }: { status: CommitmentStatus }) => (
  <span className={`${base} ${COMMITMENT_LABELS[status].className}`}>{COMMITMENT_LABELS[status].text}</span>
);

export const DealStatusBadge = ({ status }: { status: DealStatus }) => (
  <span className={`${base} ${DEAL_LABELS[status].className}`}>{DEAL_LABELS[status].text}</span>
);

const ORDER_LABELS: Record<OrderStatus, { text: string; className: string }> = {
  pending: { text: "대기중", className: "bg-amber-100 text-amber-800" },
  accepted: { text: "수락됨", className: "bg-sky-100 text-sky-800" },
  rejected: { text: "거절됨", className: "bg-red-100 text-red-700" },
  cancelled: { text: "취소됨", className: "bg-stone-200 text-stone-600" },
  fulfilled: { text: "납품완료", className: "bg-emerald-100 text-emerald-800" },
};

export const OrderStatusBadge = ({ status }: { status: OrderStatus }) => (
  <span className={`${base} ${ORDER_LABELS[status].className}`}>{ORDER_LABELS[status].text}</span>
);
